export default __webpack_public_path__ + "static/media/Win.d23e01e5.png";